import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getData } from "../../services/generalService";
import { AccountDetailsObj } from "../../utils/types";

const initialState: AccountDetailsObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getAccountData = createAsyncThunk(
  "loans/getAccountDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const accountDetailsSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAccountData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAccountData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getAccountData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default accountDetailsSlice.reducer;
